import { ChangeDetectionStrategy, Component, ViewChild, OnInit, Renderer2, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core'
import { FormGroupDirective, Validators, FormGroup, FormControl } from '@angular/forms'

import { ValidatorFactories, } from '../../../core/validators'
import { FormsService } from '../../../core/services/forms.service'
import { Observable } from 'rxjs';
import { select, Store } from '@ngrx/store';
import * as fromBase from '../../../base/reducers';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

const passwordValidator = ValidatorFactories.password(6, false, true, true, true)

@Component({
  selector: 'app-create-account-page',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreateAccountPageComponent implements OnInit, OnChanges {
  fullWidthView$: Observable<boolean>
  clientNumberImageSrc: string
  form: FormGroup
  submitting: boolean = false

  @ViewChild(FormGroupDirective) formGroupDir: FormGroupDirective

  @Input() userAccountNeedsValidation: boolean
  @Input() error: any
  @Input('submitting') set submitSetter(value: boolean) {
      this.submitting = value

      if(this.form)
          if(value)
              this.form.disable()
          else
              this.form.enable()
  }

  @Output('onSubmit') submitEvent = new EventEmitter<any>()

  constructor(
    private forms: FormsService,
    private store: Store<any>,
    private renderer: Renderer2,
    private modalService: NgbModal
  ) {
    this.store.pipe(select(fromBase.getTenantCode))
      .subscribe(tentantCode => {
        this.clientNumberImageSrc = 'https://res.cloudinary.com/orderfield/image/upload/v1554992673/'+ tentantCode + '/miscellaneous/whereismyclientnumber.jpg';
      })

    this.fullWidthView$ = store
      .pipe(
        select(fromBase.isFullWidthViewEnabled)
      )

      this.form = new FormGroup({
        customerCode: new FormControl('', Validators.required),
        zipCode: new FormControl('', Validators.required),
        fullname: new FormControl('', Validators.required),
        email: new FormControl('', [Validators.required, Validators.email]),
        password: new FormControl('', [Validators.required, passwordValidator])
      })

    // this.form = this.forms.group({
    //   customerCode: [
    //     '', [Validators.required], 'create-acc.fields.customer-code'
    //   ],
    //   zipCode: [
    //     '', [Validators.required], 'create-acc.fields.postal'
    //   ],
    //   fullname: [
    //     '', [Validators.required], 'create-acc.fields.fullname'
    //   ],
    //   email: [
    //     '', [Validators.required, Validators.email], 'create-acc.fields.email'
    //   ],
    //   password: [
    //     '', [Validators.required, passwordValidator], 'create-acc.fields.password'
    //   ]
    // })

  }

  ngOnInit() {
    // add login class to body for background image
    this.renderer.addClass(document.body, 'login');

    // If userAccountNeedsValidation is false, zipCode is also required
    if (!this.userAccountNeedsValidation) {
      this.form.addControl('zipCode', new FormControl('', Validators.required))
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.userAccountNeedsValidation && changes.userAccountNeedsValidation.currentValue) {
      // userAccountNeedsValidation is true, remove the zipCode from the form since this is not needed then.
      this.form.removeControl('zipCode')
    }
  }

  ngOnDestroy() {
    // remove login class
    this.renderer.removeClass(document.body, 'login');
  }

  submitForm() {
    if(this.form.valid) {
        this.submitEvent.emit(this.form.value)
    }
  }

  openModal(content: string) {
    this.modalService.open(content, {backdropClass: 'dark-backdrop', windowClass: 'clientnumbermodal'});
  }
}
